<template>
  <div class="calculator-widget mt-2">
      <div class="display">
          {{ result }}
      </div>
      <div class="buttons">
          <button v-for="button in buttons" :key="button" @click="addToExpression(button)" :class="{ 'action-button': isNaN(button) }">
              {{ button }}
          </button>
          <button @click="calculate()" class="calculate-button">=</button>
          <button @click="clearExpression()" class="clear-button">C</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
      return {
          expression: '',
          buttons: [7, 8, 9, '/', 4, 5, 6, '*', 1, 2, 3, '-', 0, '.', '+']
      };
  },
  computed: {
      result() {
          return this.expression;
      }
  },
  methods: {
      addToExpression(button) {
          this.expression += button;
      },
      calculate() {
          try {
              this.expression = eval(this.expression).toString();
          } catch (e) {
              this.expression = 'Error';
          }
      },
      clearExpression() {
          this.expression = '';
      }
  }
}
</script>

<style scoped>
.calculator-widget {
  width: 100%;
  border: 1px solid #ccc;
  padding: 10px;
}

.display {
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  padding: 0 5px;
  background-color: #f9f9f9;
  text-align: left;
  font-size: 20px;
}

.buttons {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
}

button {
  height: 40px;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  font-size: 18px;
}

.action-button {
  background-color: #dceeff;
}

.calculate-button {
    background-color: #8dc7ff;
}

.clear-button {
    background-color: #ff8d8d;
}

</style>
